// @ts-ignore
const appSetup = window.appSetup || {};
const locale = appSetup.localization?.locale || 'en_US';

const state = () => ({
  professions: [],
});

const mutations = {
  setProfessions(currentState, payload) {
    currentState.professions = payload;
  },
};

const actions = {
  async getChannelOptions({ state: currentState, commit }) {
    if (currentState.professions.length !== 0) return;
    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('appSetup.channelOptions', { locale }),
      );
      if (data.channels) {
        const professions = Object.entries(data.channels || {}).map(([, v]) => ({
          ...v[0],
          label: v[0].Name,
          // @ts-ignore
          options: Object.entries(v.childrens || {}).map(([, v2]) => ({
            ...v2[0],
            label: v2[0].Name,
            value: v2[0].Id,
          })),
        }));
        commit('setProfessions', professions);
      }
    } catch (e) {
      console.error(e);
    }
  },
};

const getters = {
  professions: (currentState) => currentState.professions,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
